import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import MDBox from "../../MDBox";
import MDTypography from "../../MDTypography";
import DeleteIcon from "@mui/icons-material/Delete.js";

import activities from "../../activities";
import Fab from "@mui/material/Fab";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

function ActivityParams({ params, onChange }) {
  const handleActivitySelection = (activityType) => onChange({ ...params, activityType });
  const activity = params.activityType && activities[params.activityType];
  const Icon = activity && activity.icon;
  const Configurator = activity && activity.Configurator;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        {!activity && (
          <>
            <MDBox display="flex" alignItems="center" flexWrap="wrap">
              {Object.keys(activities).map((activityId) => {
                const activity = activities[activityId];
                const Icon = activity.icon;

                return (
                  <MDBox
                    key={activityId}
                    sx={{
                      border: "1px solid silver",
                      padding: 2,
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      position: "relative",
                      minWidth: 120,
                      maxWidth: 240,
                      margin: 1,
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#f8f9fa",
                      },
                    }}
                    onClick={() => handleActivitySelection(activityId)}
                  >
                    <Icon sx={{ width: 64, height: 64, mb: 1 }} />
                    <MDTypography
                      component="div"
                      variant="caption"
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        width: "100%",
                      }}
                    >
                      {activity.title}
                    </MDTypography>
                  </MDBox>
                );
              })}
            </MDBox>
          </>
        )}
        {!!activity && (
          <MDBox display="flex" alignItems="center">
            <Icon sx={{ width: 32, height: 32 }} />
            <MDTypography
              component="div"
              variant="h5"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                flex: 1,
              }}
            >
              {activity.title}
            </MDTypography>
            <Fab size="small" color="error" onClick={() => handleActivitySelection(null)}>
              <DeleteIcon sx={{ height: "24px", width: "24px" }} />
            </Fab>
          </MDBox>
        )}
      </Grid>
      <Grid item xs={12}>
        <MDBox sx={{ overflow: "auto", maxHeight: "45vh" }}>
          {Configurator && (
            <MDBox>
              <Configurator params={params} onChange={onChange} />
            </MDBox>
          )}
          <MDBox sx={{ borderTop: "1px solid rgba(0, 0, 0, 0.25)", mt: 1.5, pt: 2 }}>
            <FormControl fullWidth>
              <InputLabel id="validation-mark-label">
                Note de passage (validation automatique)
              </InputLabel>
              <Select
                labelId="validation-mark-label"
                id="validation-mark"
                value={
                  params.validationMark || params.validationMark === 0 ? params.validationMark : "-"
                }
                label="Note de passage (validation automatique)"
                onChange={(e) => onChange({ ...params, validationMark: e.target.value })}
              >
                {["-", 0, 25, 50, 75, 80, 85, 90, 95, 100].map((mark) => (
                  <MenuItem key={mark} value={mark}>
                    {mark === "-" ? "Pas de validation automatique" : mark + "%"}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <MDTypography
              variant="caption"
              component="div"
              sx={{ fontStyle: "italic", lineHeight: "1.5", mt: 0.25 }}
            >
              Attribuer une note de passage permettra la validation de l&apos;étape de façon
              automatique.
            </MDTypography>
          </MDBox>
        </MDBox>
      </Grid>
    </Grid>
  );
}
ActivityParams.propTypes = {
  params: PropTypes.object,
  onChange: PropTypes.func,
};

export default ActivityParams;
